export const login__peacePlanCodeArray = [
  'TID1',
  'TID2',
  'TID3',
  'TID4',
  'TID5',
  'TID6',
  'TID7',
  'TSD6',
  'TSD7',
];
export const login__singlePayArr = [
  'US02',
  'US05',
  'US01',
  'US04',
  'US03',
  'US06',
  'US11',
  'US12',
  'US13',
  'US14',
  'US09',
  'US10',
  'TT37',
  'TT23',
  'TT34',
  'TT25',
  'TT28',
  'TT31',
  'TT04',
  'TT03',
  'TT08',
  'TT05',
  'TT06',
  'TT07',
  'UPW1', // Temporary for disabling Wealth Plus
  'UPW2', // Temporary for disabling Wealth Plus
  'UPW3', // Temporary for disabling Wealth Plus
  'UUW1', // Temporary for disabling Wealth Plus
  'UUW2', // Temporary for disabling Wealth Plus
  'UUW3', // Temporary for disabling Wealth Plus
  'UP01', // Temporary for disabling Golden 7
  'ELB2', // Temporary for disabling FutureSure Plus
  'ELA2', // Temporary for disabling FutureSure Plus
  'EBB2', // Temporary for disabling FutureSure Plus
  'EBA2', // Temporary for disabling FutureSure Plus
];

// Risk Status Codes
export const login__statusArray = [
  'IF', // Inforce - Policy is ACTIVE
  'LA', // Lapsed - Policy is INACTIVE due to non-payment of premium within the grace period
  'TR', // Terminated - Policy is INACTIVE due to end of policy coverage
  'MA', // Matured - Policy is INACTIVE due to reaching the maturity date
  'PS', // Proposal - Policy is not yet ISSUED
  'UW', // Underwriting - Policy is still in the process of UNDERWRITING
  'NP', // New Business Pending - Policy is PENDING for issuance because of incomplete requirements
  'NC', // New Business Counter Offer - Policy is PENDING for issuance with counter offer from issuer
];
export const login__insuranceTypeArray = ['Trad', 'Vul'];

// Premium Status Codes For Login
export const login__premiumStatusCodeArray = [
  'PP', // Premium Paying
  'HA', // Premium Holiday
  'FP', // Fully Paid
  'PS', // Proposal
  'UW', // Underwriting
  'NP', // New Business Pending
  'NC', // New Business Counter Offer
  'LA', // Lapsed
];

// Premium Status Codes For Initial Payment
export const premiumStatusCodeArrayForInitialPayment = [
  'PS', // Proposal
  'UW', // Underwriting
  'NP', // New Business Pending
  'NC', // New Business Counter Offer
];

export const login__PAYMENTMETHOD_C = 'C';
export const login__PAYMENTMETHOD_S = 'S';
export const login__PAYMENTMETHOD_R = 'R';
export const login__PAYMENTMETHOD_D = 'D';
export const login__STATUSCODE_LA = 'LA';
export const login__STATUSCODE_TR = 'TR';
export const login__STATUSCODE_MA = 'MA';
export const login__PREMIUMSTATUSCODE_FP = 'FP';
export const login__PREMIUMSTATUSCODE_SP = 'SP';

export const login__go_to_payment = '/payment';
export const login__login_body = 'Pay your premium in just a few clicks!';

export const login__iconType = 'la la-exclamation-circle';
export const login__iconClose = 'la la-times';
export const login__message_PolNo_Bday_NotMatch = `We’re unable to verify your details. Please enter the Policy Number shown on your billing statement or policy document and make sure you’re using the Policy Owner’s Date of Birth.`;

export const login__message_Not_Available = `This service is not available for this policy. Please contact your insurance agent for assistance with alternative payment options.`;
export const login__message_Group_Policy = `This is a Group Policy, and payments cannot be processed through the online portal. Please coordinate your premium payment directly with your Bank Partner following your group’s standard payment instructions.`;

export const login__message_Server_Error = `Sorry, this facility is currently not available at the moment. Kindly retry in an hour.`;
export const login__message_Terminated = `Your Account has been terminated.`;
export const login__message_AutoDebit =
  'This policy is currently enrolled in Auto Debit/Auto Charge facility.';
export const login__text_confirm_warning = 'Are you sure you want to proceed?';

/************************************/
export const privacy__body =
  'By clicking next, I consent to the processing of my personal data for the purpose of paying my premium and in accordance with FWD’s Privacy Policy ';
export const privacy__title = 'Privacy Policy | FWD Life PH.';

/************************************/
export const info__body =
  'You can find your Policy Number on your billing statement or any other policy document. You can also ';
export const info__chat_with_us = ' chat with us ';
export const info__body_inquire = 'to inquire.';

/************************************/
export const paymentform__error_polno = 'Please enter Policy number';
export const paymentform__title = 'Input your Policy Number and Birthdate';

/************************************/
export const policydetail__Title = 'Policy Details';
export const policydetail__Title_PolNo = 'Policy Number';
export const policydetail__Title_Plan = 'Plan';
export const policydetail__Title_Status = 'Status';
export const policydetail__Title_PremiumDue = 'Premium Due';
export const policydetail__Title_AmountDue = 'Total Amount Due';
export const policydetail__Title_DueDate = 'Due Date';
export const policydetail__tooltip_amountdue =
  'Total amount due includes all unpaid premiums plus charges less excess payments. For inquiries, please go to Chat with FWD below where a Customer Connect Representative is available to assist you.';
export const policydetail__peso = '₱';

/************************************/
export const paymenttype__title = 'Select your Payment Type';
export const paymenttype__option_renewalpremium = 'Renewal Premium';
export const paymenttype__option_topup = 'Top-up';
export const paymenttype__tooltip_renewalpremium =
  'Pay for your insurance premium';
export const paymenttype__tooltip_topup =
  'Make an additional investment to increase the fund value of your policy, subject for approval';
export const paymenttype__topup_warning =
  'This service will be available soon. For assistance on top-up requests,';
export const paymenttype__topup_chatwithus = ' chat with us ';
export const paymenttype__topup_viatapp = 'or top-up via';
export const paymenttype__topup_fwdtapp = ' FWD Omne';

/************************************/
export const maintenance__redirect = '/maintenance';
export const maintenance__title = 'MAINTENANCE IN PROGRESS';
export const maintenance__header = `We're making things better for you!`;
export const maintenance__body = `Our payment portal is currently undergoing scheduled maintenance to give you better and faster experience. We will be back shortly.`;
export const maintenance__body_contact =
  'For any other inquiries, you may contact our Customer connect via:';
export const maintenance__option_hotline = 'HOTLINE';
export const maintenance__option_livechat = 'LIVE CHAT';
export const maintenance__option_email = 'EMAIL';
export const maintenance__go_back = 'BACK TO FWD HOME';

export const amlaLimit = 500000;
export const fastLanePlanCodes = ['UL2P', 'UI2P'];
